import React, { Component } from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputLabel from "@material-ui/core/InputLabel";
// core components
import GridItem from "../../components/Grid/GridItem.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import CustomInput from "../../components/CustomInput/CustomInput.jsx";
import Button from "../../components/CustomButtons/Button.jsx";
import Card from "../../components/Card/Card.jsx";
import CardHeader from "../../components/Card/CardHeader.jsx";
import CardAvatar from "../../components/Card/CardAvatar.jsx";
import CardBody from "../../components/Card/CardBody.jsx";
import CardFooter from "../../components/Card/CardFooter.jsx";
import { spinnerService } from "@chevtek/react-spinners";
import imgPlaceholder from "../../assets/img/person-placeholder.jpg";
import Icon from "@material-ui/core/Icon";
import Avatar from "@material-ui/core/Avatar";
import awsConfigSettings from "../../aws-exports";
import { getCustomerTeam } from "../../graphql/queries";
import * as actionTypes from "../../redux/actions";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import TextField from "@material-ui/core/TextField";

import _ from "lodash";
import { flowRight } from "lodash";

import { toast } from "react-toastify";
import Input from "@material-ui/core/Input";

import { Auth, API, graphqlOperation, Storage } from "aws-amplify";
import CognitoIdentityServiceProvider from "aws-sdk/clients/cognitoidentityserviceprovider";
import gql from "graphql-tag";
import { withApollo } from "react-apollo";
import { createCustomerTeam } from "../../graphql/mutations";

import { connect } from "react-redux";

const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none"
  }
};

const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
class CreateTeam extends Component {
  constructor(props) {
    super(props);
    this.state = {
      empType: null,
      empName: "",
      phoneNo: "",
      email: "",
      oldPassword: "",
      _oldPassword: {
        value: "",
        isValid: true,
        err: ""
      },
      password: "",
      _password: {
        value: "",
        isValid: true,
        err: ""
      },
      cPassword: "",
      _cPassword: {
        value: "",
        isValid: true,
        err: ""
      },
      accountStatus: null,
      verifyPhone: false,
      verifyEmail: false,
      emailErr: "",
      phoneErr: "",
      notes: "",
      username: null,
      _username: {
        value: "",
        isValid: true,
        err: ""
      },
      passwordDialog: false,
      registrationDate: "",
      id: "",
      userId: "",
      isEdit: false,
      errors: {
        cognito: false,
        blankfield: false,
        passwordmatch: false
      },
      emailValidate: true,
      emailFeedback: null
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  async componentDidMount() {
    let empType = this.props.match.params.type;
    this.setState({ empType });
  }

  clearErrorState = () => {
    this.setState({
      errors: {
        cognito: false,
        blankfield: false,
        passwordmatch: false
      }
    });
  };
  checkValidate = () => {
    let { passwordValidate, phoneValidated } = this.state;
    if (!passwordValidate) {
      document.getElementById("password").focus();
      return false;
    } else if (!phoneValidated) {
      document.getElementById("phoneNo").focus();
      return false;
    } else {
      return true;
    }
  };
  async handleSubmit() {
    spinnerService.show("mySpinner");
    const self = this;
    let isError = false;
    let {
      empType,
      empName,
      phoneNo,
      email,
      password,
      cPassword,
      accountStatus,
      notes,
      username,
      _username,
      verifyEmail,
      verifyPhone,
      _password
    } = this.state;
    const { client, user, empProfile } = this.props;
    let custUsername = user.username;
    let userType = null;
    if (
      user !== null &&
      user !== "notFound" &&
      user.signInUserSession.idToken.payload["cognito:groups"] !== undefined
    ) {
      userType = user.signInUserSession.idToken.payload["cognito:groups"][0];
    }
    if (userType === "Dispatchers") {
      let emp = null;
      if (
        empProfile === undefined ||
        empProfile === "" ||
        empProfile === null
      ) {
        emp = (await client.query({
          query: gql(getCustomerTeam),
          fetchPolicy: `network-only`,
          variables: { id: user.username }
        })).data.getCustomerTeam;
      } else emp = empProfile;
      this.props.storeEmpProfile(emp);
      custUsername = emp.customer.id;
    }
    if (["", null, undefined].includes(phoneNo) || phoneNo.length < 10) {
      this.setState({
        phoneErr: "Valid Phone Number is Required"
      });
      spinnerService.hide("mySpinner");
      return;
    } else if (["", null, undefined].includes(_username.value)) {
      this.setState({
        _username: {
          value: _username.value,
          isValid: false,
          err: "This is Required"
        }
      });
      spinnerService.hide("mySpinner");
      return;
    } else if (
      ["", null, undefined].includes(_password.value) ||
      _password.value.length < 6
    ) {
      this.setState({
        _password: {
          value: _password.value,
          isValid: false,
          err:
            _password.value.length < 6 && _password.value.length > 0
              ? "Password Must be 6 Characters"
              : "This is Required"
        }
      });
      spinnerService.hide("mySpinner");
      return;
    } else {
      (password = _password.value), (username = _username.value.toLowerCase());
      this.setState({
        password: _password.value,
        username: _username.value.toLowerCase()
      });
      phoneNo = phoneNo.replace("(", "");
      phoneNo = phoneNo.replace(")", "");
      phoneNo = phoneNo.replace("-", "");
      phoneNo = phoneNo.replace(" ", "");
      phoneNo = "+1" + phoneNo;
      ////make new signup here
      let userPoolId = awsConfigSettings.aws_user_pools_id; //"us-east-2_EZT5XPRKI";
      let customerId = custUsername; //this.props.user.username;
      const { addTeamMember } = this.props; //.addTeamMember
      var params = {
        UserAttributes: [
          {
            Name: "email" /* required */,
            Value: ["", null, undefined].includes(email) ? "" : email
          },
          {
            Name: "phone_number" /* required */,
            Value: ["", null, undefined].includes(phoneNo) ? "" : phoneNo
          },
          {
            Name: "phone_number_verified" /* required */,
            Value: verifyPhone || verifyPhone === "true" ? "true" : "false"
          },
          {
            Name: "email_verified" /* required */,
            Value: verifyEmail || verifyEmail === "true" ? "true" : "false"
          }
        ],
        UserPoolId: userPoolId /* required */,
        Username: username /* required */,

        DesiredDeliveryMediums: ["SMS"] /*EMAIL*/,
        ForceAliasCreation: true,
        // MessageAction: RESEND | SUPPRESS,
        TemporaryPassword: password
      };

      let credentials = await Auth.currentCredentials();
      let client = await Promise.resolve(
        new CognitoIdentityServiceProvider({
          apiVersion: "2016-04-18",
          credentials: Auth.essentialCredentials(credentials),
          region: "us-east-2"
        })
      );
      let groupName = this.state.empType;
      await client.adminCreateUser(params, function(err, data) {
        if (err) {
          spinnerService.hide("mySpinner");
          //if (err.stack.includes("UsernameExistsException"))
          //toast.error("This username already exists. Please try another.");
          toast.error(err.message);
        } else {
          //this.setState({ userId: data.User.Username });
          client
            .adminAddUserToGroup({
              GroupName: groupName,
              UserPoolId: userPoolId,
              Username: data.User.Username
            })
            .promise();
          try {
            let input = {
              id: data.User.Username,
              customerTeamCustomerId: customerId,
              empType: empType
            };
            if (!_.isEmpty(empName)) input.empName = empName;
            if (!_.isEmpty(phoneNo)) input.phoneNo = phoneNo;
            if (!_.isEmpty(email)) input.email = email;
            // if (!_.isEmpty(email)) input.username = username;
            input.accountStatus = "ACTIVE";
            if (!_.isEmpty(notes)) input.notes = notes;

            var result = API.graphql(
              graphqlOperation(createCustomerTeam, { input })
            );

            //update redux store with updated
            addTeamMember(input);
            spinnerService.hide("mySpinner");
            self.props.history.goBack();
            toast.success("User Created!");
            // "User Created", result;
          } catch (err) {
            
            spinnerService.hide("mySpinner");
          }
        }
      });
    }
  }
  getTodayDate = () => {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    var yyyy = today.getFullYear();

    today = yyyy + "-" + mm + "-" + dd;
    return today;
  };
  onInputChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  };
  _onInputChange = e => {
    this.setState({
      [e.target.id]: {
        value: e.target.value,
        isValid: true,
        err: ""
      }
    });
  };
  onPasswordChange = (e, otherPassword) => {
    e.currentTarget.type = "password";
    this.setState({ [e.target.id]: e.target.value });
    if (e.target.value !== otherPassword)
      this.setState({ passwordValidate: false });
    else this.setState({ passwordValidate: true });
  };
  onEmailChange = e => {
    let { value } = e.target;
    value = value.toLowerCase();
    this.setState({ email: value });
    if (/.+@.+\.[A-Za-z]+$/.test(value)) {
      Auth.signIn({ username: value, password: "123" })
        .then(res => {})
        .catch(err => {
          if (err.code !== "UserNotFoundException")
            this.setState({
              emailValidate: false,
              emailFeedback: "Email already exist!"
            });
          else this.setState({ emailValidate: true });
        });
    } else {
      this.setState({ emailValidate: false, emailFeedback: "" });
    }
  };
  onPhoneChange = e => {
    let { id, value } = e.target;
    var phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    if (value.match(phoneno)) {
      this.setState({ [id]: value, phoneValidated: true });
    } else {
      this.setState({ [id]: value, phoneValidated: false });
    }
  };

  render() {
    const { classes } = this.props;

    return (
      <div>
        <GridContainer>
          {" "}
          <GridItem xs={12} sm={12} md={2}></GridItem>
          <GridItem xs={12} sm={12} md={8}>
            <Card>
              <CardHeader color="primary">
                <h4 className={classes.cardTitleWhite}>
                  Create {this.state.empType} Account
                </h4>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <TextField
                      style={{ paddingTop: 5 }}
                      id="_username"
                      onChange={this._onInputChange}
                      placeholder="Username"
                      type="text"
                      value={this.state._username.value}
                      error={!this.state._username.isValid}
                      helperText={this.state._username.err}
                      required
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <TextField
                      style={{ paddingTop: 5 }}
                      id="_password"
                      onChange={this._onInputChange}
                      placeholder="Password"
                      type="password"
                      value={this.state._password.value}
                      error={!this.state._password.isValid}
                      helperText={this.state._password.err}
                      required
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <TextField
                      style={{ paddingTop: 15 }}
                      id="empName"
                      onChange={this.onInputChange.bind(this)}
                      placeholder="Employee Name"
                      type="text"
                      value={this.state.empName}
                      required
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <TextField
                      style={{ paddingTop: 15 }}
                      id="email"
                      onChange={e => {
                        this.onInputChange(e);
                        this.setState({ verifyEmail: false });
                      }}
                      placeholder="Email"
                      type="text"
                      value={this.state.email}
                    />
                    <FormGroup row>
                      <FormControlLabel
                        control={
                          <Checkbox
                            disabled={!re.test(this.state.email.toLowerCase())}
                            checked={this.state.verifyEmail}
                            onChange={e => {
                              if (re.test(this.state.email.toLowerCase())) {
                                this.setState({
                                  verifyEmail: e.target.checked
                                });
                              } else {
                                this.setState({
                                  verifyEmail: false
                                });
                              }
                            }}
                            value={this.state.verifyEmail}
                          />
                        }
                        label="Mark as Verified"
                      />
                    </FormGroup>
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <TextField
                      autoFocus
                      required={true}
                      margin="dense"
                      id="phoneNo"
                      label="Phone Number"
                      placeholder="+1(541) 754-3010"
                      type="tel"
                      error={this.state.phoneErr}
                      helperText={this.state.phoneErr}
                      value={this.state.phoneNo}
                      onChange={e => {
                        this.onInputChange(e);
                        this.setState({ verifyPhone: false, phoneErr: "" });
                      }}
                    />
                    <FormGroup row>
                      <FormControlLabel
                        control={
                          <Checkbox
                            disabled={this.state.phoneNo.length < 9}
                            checked={this.state.verifyPhone}
                            onChange={e => {
                              if (this.state.phoneNo.length >= 10) {
                                this.setState({
                                  verifyPhone: e.target.checked
                                });
                              } else {
                                this.setState({
                                  verifyPhone: false
                                });
                              }
                            }}
                            value={this.state.verifyPhone}
                          />
                        }
                        label="Mark as Verified"
                      />
                    </FormGroup>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <TextField
                      style={{ paddingTop: 25 }}
                      id="notes"
                      onChange={this.onInputChange.bind(this)}
                      placeholder="Notes"
                      type="text"
                      value={this.state.notes}
                    />
                  </GridItem>
                </GridContainer>
              </CardBody>
              <CardFooter>
                {" "}
                <div style={{ float: "right", marginTop: 20 }}>
                  <Button
                    color="secondary"
                    onClick={() =>
                      this.props.history.push(
                        "/profile/list/" + this.props.match.params.type
                      )
                    }
                  >
                    Back
                  </Button>
                  <Button color="primary" onClick={() => this.handleSubmit()}>
                    Create User
                  </Button>
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={12} md={2}></GridItem>
        </GridContainer>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.config.user,
    client: state.config.client,
    profile: state.config.profile,
    empProfile: state.config.empProfile
  };
};
const mapDispatchToProps = dispatch => {
  return {
    addTeamMember: data => dispatch(actionTypes.addTeamMember(data)),
    storeEmpProfile: data => dispatch(actionTypes.storeEmpProfile(data))
  };
};
export default CreateTeam = connect(
  mapStateToProps,
  mapDispatchToProps
)(flowRight(withApollo)(withStyles(styles)(CreateTeam)));



// WEBPACK FOOTER //
// ./src/customers/profile/CreateTeam.jsx